import { getTokenSilently } from "./auth";

const LEGACY_APP_URL = import.meta.env.VITE_LEGACY_APP_URL || "";

export namespace AppSwitch {
  export async function goToLegacy(workspaceId: string) {
    const token = await getTokenSilently();
    if (!token) {
      console.error("AppSwitch: Token could not be retrieved.");
      return;
    }
    if (!workspaceId) {
      console.error("AppSwitch: Workspace ID could not be retrieved.");
      return;
    }
    const targetUrl = `${LEGACY_APP_URL}/callback/fresh?token=${encodeURIComponent(
      token
    )}&workspace=${workspaceId}`;
    window.location.href = targetUrl;
  }
}
